import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=c31b119a"
import script from "./ContactCard.vue?vue&type=script&lang=ts"
export * from "./ContactCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports